import { CSS } from "../../constants/css";
import { getChildIndex } from "../../utils/dom";

const instance = ($el: HTMLElement) => {
  const dom = {
    $contents: $el.querySelectorAll<HTMLElement>(".js-tab-content"),
    $mobileTabs: $el.querySelector<HTMLElement>(".js-mobile-tab"),
    $tabs: $el.querySelectorAll<HTMLElement>(".js-tab"),
    $tabsList: $el.querySelector<HTMLElement>(".js-tabs-list"),
  };

  const toggleMobileTabs = () => {
    dom.$tabsList?.classList.toggle(CSS.open);
  };

  const selectTab = (e: MouseEvent) => {
    if (!(e.currentTarget instanceof HTMLElement)) {
      return;
    }

    const selectedIndex = getChildIndex(e.currentTarget);

    if (selectedIndex >= dom.$tabs.length) {
      return;
    }

    dom.$tabs.forEach(($tab) => {
      $tab.classList.remove(CSS.active);
    });

    dom.$contents.forEach(($content) => {
      $content.classList.remove(CSS.active);
    });

    dom.$tabs[selectedIndex].classList.add(CSS.active);
    dom.$contents[selectedIndex].classList.add(CSS.active);

    toggleMobileTabs();
  };

  dom.$tabs.forEach(($tab) => {
    $tab.addEventListener("click", selectTab);
  });

  dom.$mobileTabs?.addEventListener("click", toggleMobileTabs);
};

export default () => {
  const $tabs = document.querySelectorAll<HTMLElement>(".js-tabs");

  $tabs.forEach(($element) => {
    instance($element);
  });
};
